export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/Vector.44872c07.svg","height":24,"width":26,"blurWidth":0,"blurHeight":0};